import { css } from '@emotion/css';
import { Component } from 'Shared/frontend/widgets/Component';
import { ChildKeyContext } from 'Shared/frontend/widgets/StylesProvider';
import { For } from 'solid-js';


export function Vertical(P)
{
	return (
		<div class={css(P.styling.css ?? {})}>
			<For each={P.items}>{(item,index) =>
				<ChildKeyContext.Provider value={index}>
					<Component {...item} />
				</ChildKeyContext.Provider>
			}</For>
		</div>
	);
}

